<script>
import CandidateListContainer from '@components/candidate/candidate-list-container.vue'

export default {
  name: 'CandidatesView',
  components: { CandidateListContainer },
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [
        {
          name: 'description',
          content: this.$t('candidateList.metaDescription'),
        },
      ],
    }
  },
}
</script>

<template>
  <CandidateListContainer />
</template>
